var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"text-center pt-1 mb-1"},[_vm._v("© Copyright 2016 - "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://twinsoftbd.com","target":"_blank"}},[_vm._v("Twinsoft Solution Bangladesh")]),_vm._v(". All rights reserved. "),_c('span',{staticClass:"text-success"},[_vm._v("V-C4.2")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }